/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SUBMIT_KYC_DATA } from "../graphql";
import { VApplication } from "../../../application";

import { toHeaderCase } from "js-convert-case";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IKYCSubmitProps {
  firstName?: string;
  lastName?: string;
  gender?:string;
  streetAddress?: string;
  city?: String;
  country?: string;
  telephone?: string;
  occupation?: string;
  addressProofType?: string;
  idProofType?: string;
  addressProof?: any;
  idProof?: any;
}

export interface IKYCSubmitMethods extends IPluginMethodMap {
  getKYCSubmitProps(args: IKYCSubmitProps): Promise<any>;
}

export class KYCSubmitService implements IAgentPlugin {
  readonly methods: IKYCSubmitMethods;

  constructor() {
    this.methods = {
      getKYCSubmitProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IKYCSubmitProps) {
    console.log(`args in kyc submit`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.mutate({
          mutation: SUBMIT_KYC_DATA,
          variables: {
            input: {
              gender:args?.gender,
              firstName: args?.firstName,
              lastName: args?.lastName,
              documents: this.getDocs(args),
              address: {
                addressLine1: args?.streetAddress,
                city: args?.city,
                country: args?.country,
              },
              occupation: args?.occupation,
              primaryContactNo: args?.telephone,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return res?.data;
        }
      }
    } catch (err: any) {
      console.log(`submit kyc error`, err);
      return err;
      // throw Error(err?.response?.data?.error?.display_message);
    }
    // return true
  }

  private getDocs(args: any) {
    let _docs = [];
    if (args?.addressProofType && args?.addressProof) {
      _docs.push({
        doc: args?.addressProof[0]?.base64,
        type: "ADDRESS_PROOF",
        name: args?.addressProofType,
      });
    }
    if (args?.idProofType && args?.idProof) {
      _docs.push({
        doc: args?.idProof[0]?.base64,
        type: "ID_PROOF",
        name: args?.idProofType,
      });
    }
    return _docs;
  }
}
